export default {
  computed: {
    hasViewActivityLogPermission() {
      return (
        this.isMerchantAdmin ||
        this.isAdmin ||
        this.$role.verify([this.$role.VIEW_ACTIVITY_LOG])
      );
    },
    hasExportActivityLogPermission() {
      return (
        this.isMerchantAdmin ||
        this.isAdmin ||
        this.$role.verify([this.$role.EXPORT_ACTIVITY_LOG])
      );
    },
    isMerchantAdmin() {
      return this.$role.verify([this.$role.MERCHANT_ADMIN]);
    },
    isAdmin() {
      return this.$role.verify([this.$role.ADMIN]);
    },
    authenticated() {
      return this.$role.verify([
        this.$role.VIEW_ACTIVITY_LOG,
        this.$role.EXPORT_ACTIVITY_LOG,
        this.$role.MERCHANT_ADMIN,
        this.$role.ADMIN
      ]);
    }
  }
};
